<template>
    <div>

        <div class="card-body">
            <div class="tab-content">
                <div class="tab-pane active" id="activity">


                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-t">Employement History</h5>
                            <hr />
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead class="bg-info">
                                        <tr>
                                            <th>Type</th>
                                            <th>Organization</th>
                                            <th>Designation</th>
                                            <th>Pay/ Scale</th>
                                            <th>Job Profile</th>
                                            <th>Duration</th>
                                            <th style="width: 10px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ind) in experiences">
                                            <td>{{item._Type}}</td>
                                            <td>{{item.Organization}}</td>
                                            <td>{{item.Designation}}</td>
                                            <td>{{item.Pay}}</td>
                                            <td>{{item.JobProfile}}</td>
                                            <td>{{item._PeriodFrom}} to {{item._PeriodTo}}</td>
                                            <td style="white-space: nowrap">
                                                <button class="btn btn-sm btn-info" v-on:click="showModalExperience(item, ind)"><i class="fas fa-edit"></i></button>
                                                <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteExperience" v-on:click="experienceIndex = ind;"><i class="fas fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="7">
                                                <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showModalExperience()">Add New</button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="modalExperience">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Employement History</h4>
                                </div>

                                <form id="labManual" v-on:submit="saveExperience">
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Type *</label>
                                                    <select class="form-control" v-model="experience.Type" required >
                                                        <option value="0">Teaching</option>
                                                        <option value="1">Industrial</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Organization *</label>
                                                    <input max="150" class="form-control" v-model="experience.Organization" required />
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Designation *</label>
                                                    <input class="form-control" v-model="experience.Designation" required />
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Job Profile</label>
                                                    <input class="form-control" v-model="experience.JobProfile" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Pay/ Scale</label>
                                                    <input class="form-control" v-model="experience.Pay" required />
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Period From</label>
                                                    <input type="date" class="form-control" v-model="experience.PeriodFrom" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Period To</label>
                                                    <input type="date" class="form-control" v-model="experience.PeriodTo" required />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                        <button type="submit" class="btn btn-success">Save changes</button>
                                    </div>
                                </form>

                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>

                    <div class="modal fade" id="modalDeleteExperience">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Delete</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>Are you sure you want to delete this record ?</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer justify-content-between">
                                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                    <button type="button" v-on:click="deleteExperience()" class="btn btn-danger">Delete</button>
                                </div>
                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>



                </div>
            </div>
        </div>

        <div class="card-footer">
            <a class="btn btn-primary" href="../Employees/List">Back to List</a>
            <div class="float-right">
                <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
            </div>
        </div>


    </div>
</template>

<script>const axios = require('axios').default;

    export default ({
        props: {
            employeeId: Number,
        },

        data() {
            return {
                experiences: [],
                experience: { Type: 'Teaching', Organization: '', Designation: '', Pay: '', JobProfile: '', PeriodFrom: '', PeriodTo: '' },
                experienceIndex: -1,

            }
        },

        created: function () {
            this.pageLoad();
        },

        methods: {

            pageLoad() {
                startReq();
                var vm = this;
                axios.get('/api/EmployeesApi/pageLoadExperience?id=' + vm.employeeId)
                    .then(function (res) {
                        endReq();

                        if (res.data.experiences)
                            vm.experiences = res.data.experiences; 
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            showModalExperience(data, index) {

                if (data) {
                    this.experience = Object.assign({}, data);
                    this.experienceIndex = index
                }
                else {
                    this.experience = { Type: 'Teaching', Orgranization: '', Designation: '', Pay: '', JobProfile: '', PeriodFrom: '', PeriodTo: '' };
                    this.experienceIndex = -1;
                }

                $('#modalExperience').modal('show');
            },

            saveExperience(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/api/EmployeesApi/saveExperience?id=' + vm.employeeId, {
                    experience: vm.experience
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {

                            toastr.success("Saved Successfully", "Done");
                            if (vm.experienceIndex == -1)
                                vm.experiences.push(res.data.experience);
                            else {
                                vm.experiences[vm.experienceIndex] = res.data.experience;
                                vm.experienceIndex = -1;
                                $('#modalExperience').modal('hide');
                            }
                            vm.experience = { Type: 'Teaching', Organization: '', Designation: '', Pay: '', JobProfile: '', PeriodFrom: '', PeriodTo: '' };
                         }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            deleteExperience() {
                var vm = this;
                startReq();
                axios.get('/api/EmployeesApi/deleteExperience?id=' + vm.experiences[vm.experienceIndex].EmployeeExperienceID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Deleted Successfully", "Done!");
                            vm.experiences.splice(vm.experienceIndex, 1);
                            vm.experienceIndex = -1;
                            $('#modalDeleteExperience').modal('hide');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            clear() {
                location.reload();
            }

        }
    })</script>

<style>

    .h4-t {
        margin-top: -9px;
        margin-bottom: -5px;
        font-weight: 600
    }

    .h4-c {
        margin-bottom: -5px;
        font-weight: 600
    }
</style>





// WEBPACK FOOTER //
// src/components/hr/employeeExperience.vue